import React, { useEffect, useState } from "react";
import axios from "axios";
import { Loading } from "../../ui";
import { ENV, T, theme } from "../../config";
import { PieChart } from "../Charts/PieChart";

type baseDimensionDate = {
  name: string;
  rows: [{ date: string; value: number }];
  count: number;
};

interface PieDimensionProps {
  dimension: string;
  id: string;
  areaId?: string | null;
  areaRef?: string | null;
  areaApp?: string | null;
  platform?: string | null;
  from?: string;
  to?: string;
  title?: string;
  subTitle?: string;
  height?: number;
}

const PieDimension = (props: PieDimensionProps) => {
  const [loading, setLoading] = useState(true);

  const [chartData, setChartData] = useState<{
    labels: string[];
    data: string[] | number[];
  }>({ labels: [], data: [] });

  useEffect(() => {
    const getReport = async () => {
      try {
        const response = await axios.post<baseDimensionDate>(
          ENV.analytics + "/base/dimension",
          {
            dimension: props.dimension,
            area_app: props.areaApp,
            area_id: props.areaId,
            area_ref: props.areaRef,
            platform: props.platform,
            from: props.from,
            to: props.to,
          }
        );

        if (response?.data) {
          let data = [];
          let labels = [];

          response.data.rows.forEach((row: any, index: number) => {
            if (index < 5) {
              data.push(row.value);
              labels.push(T(row.name));
            }
          });

          if (response.data.count > 5) {
            let otherData = 0;
            let otherLabel = "Altro";
            response.data.rows.forEach((row: any, index: number) => {
              if (index > 4) {
                otherData = otherData + parseInt(row.value);
              }
            });
            data.push(otherData);
            labels.push(otherLabel);
          }

          setChartData({
            labels: labels,
            data: data,
          });
        }
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    };
    setLoading(true);
    getReport();
  }, [props]);

  if (!props.dimension) return null;

  return (
    <>
      <div className="overflow-hidden relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-xl bg-white">
        <div className="rounded-xl mb-0 px-4 py-3 bg-white">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full max-w-full flex-grow flex-1">
              <h6 className="uppercase text-blueGray-100 mb-1 text-xs font-semibold">
                {props.subTitle}
              </h6>
              <h2 className="text-xl font-semibold">{props.title}</h2>
              <h3 style={{ position: "absolute" }} className="text-sm">
                Sugli accessi in area
              </h3>
            </div>
          </div>
        </div>
        <div className="flex-auto" style={{ height: 388, padding: 10 }}>
          <div
            style={{
              height: "100%",
              /* marginLeft: -25,
              marginRight: -25, */
              marginTop: 0,
            }}
            className="relative h-full"
          >
            {chartData.data.length > 0 && !loading && (
              <PieChart
                id={props.id}
                data={chartData.data}
                labels={chartData.labels}
              />
            )}
          </div>
        </div>
        {loading && (
          <div className="w-full h-full absolute flex items-center justify-center py-8 bg-white rounded-lg">
            <Loading color={theme.vars.colors.greyDark} />
          </div>
        )}
      </div>
    </>
  );
};

PieDimension.defaultProps = {
  from: "2020-01-01",
  to: "today",
  title: "Values",
  subTitle: "Overview",
};

export { PieDimension };
